import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import InputMask from 'react-input-mask';
import useFormValidator from 'useFormValidator';
import moment from 'moment';
import { connect } from 'react-redux';
import CmsContext from 'context/CmsContext';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import FormInputMobile from 'modules/common/components/FormInputMobile';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { customStyle } from 'helper';
import Address from 'modules/common/address/Address';
import ViolationsList from './ViolationsList';
import ApprehendingOfficerDropdown from '../components/ApprehendingOfficerDropdown';
import ViolationsContext from './ViolationsContext';
import * as actions from '../action';
import * as c from '../constant';

function AddViolationTicketModal({
  creating,
  createOVRS,
  municipalityListApp,
  barangayListApp,
  getMunicipalityListApp,
  getBarangayListApp,
  showTransactionTrafficViolator,
  history,
}) {

  const firstDateOfLastYear = `1/1/${new Date().getFullYear() - 1}`;

  const setModal = useContext(ModalContext);
  const [formMobile, setFormMobile] = useState({
    mobile_number: '',
  });
  const cmsContext = useContext(CmsContext);
  const CMS_MASKINGS = cmsContext.findByType('MASKINGS');

  const [formData, setFormData] = useState({
    mobile_number: '',
    driver_license_validity_date_from: '',
    driver_license_validity_date_to: '',
    ovr_number: '',
    birth_date: '',
    last_name: '',
    first_name: '',
    driver_license_number: '',
    apprehended_at: '',
    vehicle_type: '',
    vehicle_plate_number: '',
    apprehending_officer_id: '',
    apprehension_municipality_code: '',
    apprehension_barangay_code: '',
    apprehension_street: '',
  });
  const validateForm = useFormValidator(formData, {
    // mobile_number: 'required',
    // driver_license_validity_date_from: 'required',
    // driver_license_validity_date_to: 'required',
    ovr_number: `required|mask:${_.get(
      CMS_MASKINGS,
      'OVR_NUMBER_REGEX'
    )}~${_.get(CMS_MASKINGS, 'OVR_NUMBER')}`,
    // birth_date: 'required',
    last_name: 'required',
    first_name: 'required',
    driver_license_number: `required|mask:${_.get(
      CMS_MASKINGS,
      'OVR_DRIVER_LICENSE_NUMBER_REGEX'
    )}~${_.get(CMS_MASKINGS, 'OVR_DRIVER_LICENSE_NUMBER')}`,
    apprehended_at: 'required|apprehended_at_before',
    vehicle_type: 'required',
    vehicle_plate_number: 'required',
    apprehending_officer_id: 'required',
    apprehension_municipality_code: 'required',
    apprehension_barangay_code: 'required',
    apprehension_street: 'required',
  });

  const mobileNumberValidator = useFormValidator(formMobile, {
    mobile_number: 'required|cellphone_number',
  });

  const [violations, setViolations] = useState([]);
  const violationsValue = { violations, setViolations };

  const [municipalityApp, setMunicipalityApp] = useState({
    label: '',
    value: 0,
  });

  const [barangayApp, setBarangayApp] = useState({
    label: '',
    value: 0,
  });

  const handleOnChangeDate = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const createDropdown = list => {
    const newList = [];
    list.map(data => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
      });
    });
    return newList;
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value.toUpperCase(),
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  useEffect(() => {
    getMunicipalityListApp({ province_code: 133900000 });
  }, []);

  useEffect(() => {
    setFormData({
      ...formData,
      discount: 0,
      extension_name: '',
      apprehension_region_code: '130000000',
      apprehension_province_code: '133900000',
    });
  }, []);

  const handleDropDownChange = key => e => {
    if (key === 'apprehending_officer_id') {
      setFormData({
        ...formData,
        apprehending_officer: e.label,
        [key]: e ? e.value : '',
      });
      return false;
    }
    return setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const handleMunicipalityAppSelect = e => {
    setMunicipalityApp(e);
    setFormData({
      ...formData,
      apprehension_municipality_code: e.value,
    });
    getBarangayListApp(
      {
        display_all: 1,
        region_code: _.get(formData, 'apprehension_region_code'),
        province_code: _.get(formData, 'apprehension_province_code'),
        municipality_code: e.value
      }
    );
  };

  const handleBarangayAppSelect = e => {
    setBarangayApp(e);
    setFormData({
      ...formData,
      apprehension_barangay_code: e.value,
    });
  };

  const handleOnSubmit = e => {
    e.preventDefault();
    if (!validateForm.response.is_passed) {
      return false;
    }

    const combineViolations = {
      ...formData,
      apprehended_at: `${moment(_.get(formData, 'apprehended_at')).format(
        'YYYY-MM-DD HH:mm'
      )}:00`,
      violations,
      mobile_number: _.get(formMobile, 'mobile_number'),
      ovr_number: _.get(formData, 'ovr_number').toUpperCase(),
      driver_license_number: _.get(
        formData,
        'driver_license_number'
      ).toUpperCase(),
      birth_date: _.get(formData, 'birth_date') || '',
      driver_license_validity_date_from:
        _.get(formData, 'driver_license_validity_date_from') || '',
      driver_license_validity_date_to:
        _.get(formData, 'driver_license_validity_date_to') || '',
    };

    return createOVRS(combineViolations, ({ data }) => {
      setModal({ isOpen: false });
      history.push(
        `/ordinance-violation-receipts/violations/list/${_.get(data, 'id')}`
      );
      showTransactionTrafficViolator(data.id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChangeText = e => {
    // remove underscore: quick fix
    const currenOnChangeValue = e.target.value.includes('_')
      ? e.target.value.replace(/_/g, '')
      : e.target.value;

    setFormData({
      ...formData,
      [e.target.name]: currenOnChangeValue,
    });
  };

  const onChangeAddress = e => {
    setFormData({
      ...formData,
      region_code: e.target.value.region_code,
      province_code: e.target.value.province_code,
      municipality_code: e.target.value.municipality_code,
      barangay_code: e.target.value.barangay_code,
      street: e.target.value.street || '',
    });
  };

  const handleOnChangeDropdown = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <label className="form-label">
          Ordinance Violation Information{' '}
          {validateForm.renderMessage('ovr_number')}
        </label>
        <div className="row pb-3">
          <div className="input-group mb-3 col-4">
            {/* <div className="input-group-prepend">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                ML-
              </span>
            </div> */}
            {/* <input
              type="text"
              required
              maxLength={10}
              mask="9999999999"
              className="form-control"
              value={_.get(formData, 'ovr_number')}
              name="ovr_number"
              onChange={onChange}
            /> */}
            <InputMask
              mask={_.get(CMS_MASKINGS, 'OVR_NUMBER')}
              required
              className="form-control"
              value={_.get(formData, 'ovr_number')}
              name="ovr_number"
              onChange={onChangeText}
              alwaysShowMask={false}
              style={{ textTransform: 'uppercase' }}
            />
          </div>
        </div>
        <label className="text-primary font-weight-bold">
          Personal Information
        </label>
        <div className="row">
          <div className="col-4 pt-1">
            <label htmlFor="last_name" className="form-label">
              Last Name: {validateForm.renderMessage('last_name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="last_name"
              onChange={onChange}
              value={_.get(formData, 'last_name') || ''}
            />
          </div>
          <div className="col-4 pt-1">
            <label htmlFor="last_name" className="form-label">
              First Name: {validateForm.renderMessage('first_name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="first_name"
              onChange={onChange}
              value={_.get(formData, 'first_name') || ''}
            />
          </div>
          <div className="col-4 pt-1">
            <label htmlFor="middle_name" className="form-label">
              Middle Name
            </label>
            <input
              className="form-control"
              type="text"
              name="middle_name"
              onChange={onChange}
              value={_.get(formData, 'middle_name') || ''}
            />
          </div>
          <div className="col-4 pt-1">
            <div className="form-label pb-1">Extension Name</div>
            <Select
              options={c.EXTENSION_NAMES}
              // styles={customStyle}
              placeholder="Select Extension name"
              value={{
                label: _.get(formData, 'extension_name') || '',
                value: _.get(formData, 'extension_name') || '',
              }}
              onChange={handleDropDownChange('extension_name')}
            />
          </div>
          <div className="col-4 pt-1">
            <label className="form-label">
              Birth Date:
              {/* {validateForm.renderMessage('birth_date')} */}
            </label>
            <DateInputPicker
              required
              className="full-input"
              onChange={handleOnChangeDate('birth_date')}
              value={_.get(formData, 'birth_date') || ''}
              maxDate={new Date()}
            />
          </div>
          <div className="col-4 pt-1">
            <label className="form-label">
              Mobile Number:{' '}
              {mobileNumberValidator.renderMessage('mobile_number')}
            </label>
            <FormInputMobile
              disableDropdown={false}
              autoComplete="off"
              autoFocus
              type="tel"
              name="mobile_number"
              onChange={setFormMobile}
              value={_.get(formMobile, 'mobile_number')}
            />
          </div>
        </div>
        <label className="text-primary font-weight-bold">Address</label>
        <div className="row pb-3">
          <div className="container-fluid">
            <Address
              value={{
                region_code: _.get(formData, 'region_code') || '',
                province_code:
                  _.get(formData, 'province_code') || '',
                municipality_code:
                  _.get(formData, 'municipality_code') || '',
                barangay_code:
                  _.get(formData, 'barangay_code') || '',
              }}
              onChange={onChangeAddress}
              type="Address"
              region_name="region_code"
              province_name="province_code"
              municipality_name="municipality_code"
              barangay_name="barangay_code"
              name="address"
              removeLabel
            />
          </div>
        </div>
        <label className="text-primary font-weight-bold">
          Vehicle Information
        </label>
        <div className="row pb-3">
          <div className="col-4 pt-2">
            <div className="form-label pb-1">
              Vehicle Type {validateForm.renderMessage('vehicle_type')}
            </div>
            <Select
              options={c.VEHICLE_TYPE}
              styles={customStyle}
              placeholder="Select Vehicle Type"
              value={{
                label: _.get(formData, 'vehicle_type') || '',
                value: _.get(formData, 'vehicle_type') || '',
              }}
              name="vehicle_type"
              onChange={handleDropDownChange('vehicle_type')}
            />
          </div>
          <div className="col-4 pt-1">
            <label htmlFor="vehicle_plate_number" className="form-label mb-1">
              Vehicle Plate Number
              {validateForm.renderMessage('vehicle_plate_number')}
            </label>
            <input
              className="form-control"
              type="text"
              maxLength="10"
              name="vehicle_plate_number"
              onChange={onChange}
              value={_.get(formData, 'vehicle_plate_number') || ''}
            />
          </div>
        </div>
        <label className="text-primary font-weight-bold">
          Violation Information
        </label>
        <div className="row pb-3">
          <div className="col-4 pt-1">
            <label htmlFor="driver_license_number" className="form-label">
              Driver License Number
              {validateForm.renderMessage('driver_license_number')}
            </label>
            <div className="input-group">
              {/* <div className="input-group-prepend">
                <span className="input-group-text" id="inputGroup-sizing-sm">
                  N
                </span>
              </div> */}
              <InputMask
                className="form-control"
                mask={_.get(CMS_MASKINGS, 'OVR_DRIVER_LICENSE_NUMBER')}
                name="driver_license_number"
                onChange={onChangeText}
                value={_.get(formData, 'driver_license_number')}
                alwaysShowMask={false}
                style={{ textTransform: 'uppercase' }}
              />
            </div>
          </div>
          <div className="col-4 pt-1">
            <label className="form-label">
              Valid From
              {/* {validateForm.renderMessage('driver_license_validity_date_from')} */}
            </label>
            <DateInputPicker
              required
              className="full-input"
              onChange={handleOnChangeDate('driver_license_validity_date_from')}
              value={_.get(formData, 'driver_license_validity_date_from') || ''}
              maxDate={new Date()}
            />
          </div>
          <div className="col-4 pt-1">
            <label className="form-label">
              Valid To
              {/* {validateForm.renderMessage('driver_license_validity_date_to')} */}
            </label>
            <DateInputPicker
              required
              className="full-input"
              onChange={handleOnChangeDate('driver_license_validity_date_to')}
              value={_.get(formData, 'driver_license_validity_date_to') || ''}
              minDate={new Date()}
            />
          </div>
        </div>
        <div className="row pb-3">
          <div className="col-6 pt-3">
            <div className="form-label  pb-1">
              Date of Apprehension
              {validateForm.renderMessage('apprehended_at')}
            </div>
            <div>
              <DateInputPicker
                withTime
                required
                className="full-input"
                onChange={handleOnChangeDate('apprehended_at')}
                value={_.get(formData, 'apprehended_at') || ''}
                minDate={new Date(firstDateOfLastYear)}
                maxDate={new Date()}
              />
            </div>
          </div>
          <div className="col-6 pt-3">
            <div className="form-label pb-1">
              Apprehending Officer
              {validateForm.renderMessage('apprehending_officer_id')}
            </div>
            <ApprehendingOfficerDropdown
              name="apprehending_officer_id"
              onChange={handleOnChangeDropdown}
              value={_.get(formData, 'apprehending_officer_id') || ''}
            />
          </div>
        </div>
        <label className="text-primary font-weight-bold">
          Address Information
        </label>
        <div className="row pb-3">
          <div className="col-4 pt-1">
            <label className="form-label">
              Select Municipality{' '}
              {validateForm.renderMessage('apprehension_municipality_code')}
            </label>
            <div>
              <Select
                name="municipality_app"
                options={createDropdown(municipalityListApp)}
                styles={customStyle}
                placeholder="Select Municipality"
                value={municipalityApp}
                onChange={e => {
                  handleMunicipalityAppSelect(e);
                }}
              />
            </div>
          </div>
          <div className="col-4 pt-1">
            <label className="form-label">
              Select Barangay{' '}
              {validateForm.renderMessage('apprehension_barangay_code')}
            </label>
            <div>
              <Select
                options={createDropdown(barangayListApp)}
                styles={customStyle}
                placeholder="Select Barangay"
                value={barangayApp}
                onChange={e => {
                  handleBarangayAppSelect(e);
                }}
              />
            </div>
          </div>
          <div className="col-4 pt-0">
            <label htmlFor="apprehension_street" className="form-label">
              Street
              {validateForm.renderMessage('apprehension_street')}
            </label>
            <input
              className="form-control"
              type="text"
              name="apprehension_street"
              onChange={onChange}
              value={_.get(formData, 'apprehension_street')}
            />
          </div>
        </div>
        <ViolationsContext.Provider value={violationsValue}>
          <ViolationsList />
        </ViolationsContext.Provider>

        <div className="d-flex justify-content-center">
          <button
            disabled={
              creating ||
              !validateForm.response.is_passed ||
              !mobileNumberValidator.response.is_passed ||
              _.isEmpty(violations)
            }
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

AddViolationTicketModal.propTypes = {
  createOVRS: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  municipalityListApp: PropTypes.instanceOf(Array).isRequired,
  barangayListApp: PropTypes.instanceOf(Array).isRequired,
  getMunicipalityListApp: PropTypes.instanceOf(Function).isRequired,
  getBarangayListApp: PropTypes.instanceOf(Function).isRequired,
  showTransactionTrafficViolator: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_OVRS) > -1,
  regionsList: _.get(api, `${c.GET_REGION}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  municipalityList: _.get(api, `${c.GET_MUNICIPALITIES}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
  municipalityListApp: _.get(api, `${c.GET_APP_MUNICIPALITIES}.list`) || [],
  barangayListApp: _.get(api, `${c.GET_APP_BARANGAYS}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(AddViolationTicketModal);
